import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/services/analytics";
import { useUiStore } from "@/stores/ui";

const PANEL_PREFIX = import.meta.env.VITE_ADMIN_PANEL_PATH || "/g7-painel-x9k";

export function PageViewTracker() {
  const analyticsEnabled = useUiStore((s) => s.analyticsEnabled);
  const cookieConsent = useUiStore((s) => s.cookieConsent);
  const location = useLocation();
  const lastTracked = useRef("");

  useEffect(() => {
    if (cookieConsent === "pending" || !analyticsEnabled) return;
    if (location.pathname.startsWith(PANEL_PREFIX)) return;

    const target = `${location.pathname}${location.search}`;
    if (lastTracked.current === target) return;
    lastTracked.current = target;

    trackPageView(location.pathname, location.search).catch(() => {
      // Coleta best-effort — não interrompe navegação.
    });
  }, [analyticsEnabled, cookieConsent, location.pathname, location.search]);

  return null;
}
